/* eslint-disable max-len */

import { PureComponent } from 'react';

import { ReactElement } from 'Type/Common.type';

import './DeliveryIcon.style';

/** @namespace Steinkrueger/Component/DeliveryIcon/Component */
export class DeliveryIconComponent extends PureComponent {
    render(): ReactElement {
        return (
            <svg
              block="DeliveryIcon"
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="26"
              viewBox="0 0 30 26"
              fill="none"
            >
                <path
                  d="M28.1797 1H8.4375C7.98447 1 7.61719 1.36728 7.61719 1.82031V12.5381C6.51945
                    12.7263 5.50718 13.2861 4.76551 14.125H4.33594V13.3047C4.33594 12.8517 3.96866
                    12.4844 3.51562 12.4844H1.82031C1.36728 12.4844 1 12.8517 1 13.3047C1 13.7577 1.36728 14.125
                    1.82031 14.125H2.69531V23.9688H1.82031C1.36728 23.9688 1 24.336 1 24.7891C1 25.2421 1.36728
                    25.6094 1.82031 25.6094H3.51562C3.96866 25.6094 4.33594 25.2421 4.33594 24.7891V23.9688H5.02855C10.2601
                    25.6245 10.0624 25.6094 10.2969 25.6094H21.5625C23.2596 25.6094 24.4484 23.924 23.8823
                    22.3281H28.1797C28.6327 22.3281 29 21.9608 29 21.5078V1.82031C29 1.36728 28.6327 1 28.1797
                    1ZM16.6406 2.64062H19.9219V6.74219H16.6406V2.64062ZM22.3828 23.1484C22.3828 23.6008 22.0148
                    23.9688 21.5625 23.9688H10.4246C5.19306 22.313 5.39075 22.3281 5.15625 22.3281H4.33594V15.7656H5.15625C5.41678
                    15.7656 5.66184 15.6419 5.81644 15.4322C7.11565 13.6706 9.75831 13.6692 11.0585 15.4322C11.2132 15.6419
                    11.4582 15.7656 11.7188 15.7656H15.8203C16.2726 15.7656 16.6406 16.1336 16.6406 16.5859C16.6406
                    17.0383 16.2726 17.4062 15.8203 17.4062H10.8984C10.4454 17.4062 10.0781 17.7735 10.0781 18.2266C10.0781
                    20.4882 11.9181 22.3281 14.1797 22.3281H21.5625C22.0148 22.3281 22.3828 22.6961 22.3828 23.1484ZM27.3594
                    20.6875C26.862 20.6875 14.8554 20.6875 14.1797 20.6875C13.1102 20.6875 12.1979 20.0018 11.8593 19.0469H15.8203C17.1773
                    19.0469 18.2812 17.9429 18.2812 16.5859C18.2812 15.229 17.1773 14.125 15.8203 14.125H12.1095C11.3679 13.2861 10.3556
                    12.7263 9.25781 12.5381V2.64062H15V7.5625C15 8.01553 15.3673 8.38281 15.8203 8.38281H20.7422C21.1952
                    8.38281 21.5625 8.01553 21.5625 7.5625V2.64062H27.3594V20.6875Z"
                  fill="#003E90"
                  stroke="#003E90"
                  strokeWidth="0.2"
                />
            </svg>
        );
    }
}

export default DeliveryIconComponent;
